import React from 'react';
import { useSelector } from 'react-redux';
import LazyLoad from 'react-lazyload';

import {selectFilteredProducts} from './../store/products';

const Products = () => {
    const filteredProducts = useSelector(selectFilteredProducts);

    return (
        <section id={"products"}>
            {filteredProducts.map((product, index) => (
                <Product key={index} product={product} />
            ))}
        </section>
    );
}

const Product = ({product}) => {
    const filterCollapsed = useSelector(state => state.app.filterCollapsed);

    return (
        <LazyLoad height={400} once className={`product ${filterCollapsed ? "extended" : ""}`}>
            {
                <a href={product.ProductUrl}><img src={product.ThumbFileName} alt={`Image of ${product.ProductNameDisplay}`} /></a>
            }
            <a className="heading" href={product.ProductUrl}><h5>{product.ProductNameDisplay}</h5></a>
            <ul>
            {
                product.Bullets.map((bc, index) => {
                    if(bc.length <= 2) return;
                    return (
                    <li key={index}>{bc}</li>
                )})
            }
            </ul>
        </LazyLoad>
    )
}

export default Products;